



































































import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { DocumentFile } from '@/types/document'
import dayjs from 'dayjs'
import { StateChanger } from 'vue-infinite-loading'

const extractNextPage = (url: string | undefined) => {
  if (!url) return null
  const pageMatch = url.match(/page=(\d+)/)
  return pageMatch ? parseInt(pageMatch[1]) : null
}

@Component({
  filters: {
    formatDate: (datetime: string) => {
      return dayjs(datetime).format('YYYY/MM/DD')
    },
    formatTime: (datetime: string) => {
      return dayjs(datetime).format('HH:mm')
    }
  },
  components: {
    Modal: () => import('@/components/common/modals/Modal.vue'),
    InfiniteLoading: () => import('vue-infinite-loading'),
    Loading: () => import('@/components/common/loadings/Index.vue')
  }
})
export default class DocumentList extends Vue {
  @Prop(Number) patientId!: number
  @Prop(String) patientName!: string

  $store!: ExStore
  items: DocumentFile[] = []
  selectedItems: number[] = []
  nextPage: number | null = 1

  @Emit('insert')
  insert() {
    return this.selectedItems
  }

  async created() {
    await this.updateItems()
  }

  async updateItems() {
    const res = await this.$api.document.fetch({
      patientId: this.patientId,
      page: 1
    })
    this.nextPage = extractNextPage(res.next)
    this.items = res.results
  }

  async appendNextItems() {
    if (!this.nextPage) return
    const res = await this.$api.document.fetch({
      patientId: this.patientId,
      page: this.nextPage
    })
    this.nextPage = extractNextPage(res.next)
    this.items = [...this.items, ...res.results]
  }

  handleChangeSelect(e: Event, itemId: number) {
    if ((e.target as HTMLInputElement).checked) {
      this.selectedItems = [
        itemId,
        ...this.selectedItems.filter(id => id !== itemId)
      ]
    } else {
      this.selectedItems = this.selectedItems.filter(id => id !== itemId)
    }
  }

  getSenderName(item: DocumentFile) {
    if (item.worker) {
      return `${item.worker.lastName}${item.worker.occupation.name}`
    }
    return this.patientName
  }

  handleNextLoad($state: StateChanger) {
    this.appendNextItems().then(() => {
      if (this.nextPage) {
        $state.loaded()
      } else {
        $state.complete()
      }
    })
  }
}
